import { DATE_FORMAT } from "helpers/common";
import Badge from "react-bootstrap/Badge";
import React from "react";
import { Link } from "react-router-dom";
import moment from 'moment-timezone';
// import UnControll

// export const selectRow = (props) => ({
//   mode: "checkbox",
//   clickToSelect: true,
//   selectionHeaderRenderer: ({ indeterminate, mode, ...rest }) => (
//     <div className="custom-control custom-checkbox">
//       <input
//         type="checkbox"
//         className="custom-control-input"
//         ref={(input) => {
//           if (input) input.indeterminate = indeterminate
//         }}
//         {...rest}
//       />
//       <label className="custom-control-label">&nbsp;</label>
//     </div>
//   ),
//   selectionRenderer: ({ mode, rowKey, ...rest }) => (
//     <div className="custom-control custom-checkbox" key={rowKey}>
//       <input type="checkbox" className="custom-control-input" {...rest} />
//       <label className="custom-control-label">&nbsp;</label>
//     </div>
//   ),
//   ...props,
// })

const STATUS = {
  "active": "Active",
  "inactive": "Inactive",
  "blocked": "Blocked",
  "deleted": "Deleted"
}

const Columns = ({ handleEditHandler, handleOpenRewardModal, permissions }) => [
  {
    dataField: "userID",
    text: "userID",
    formatter: (_, row) => <span > {row?.userDetails?.username}</span>
  },
  {
    dataField: "Username",
    text: "Username",
    formatter: (_, row) => <span className="text-capitalize">{row?.userDetails?.telegram_username ? row?.userDetails?.telegram_username : row?.userDetails?.first_name}</span>,
  },
  {
    dataField: "weekDayNo",
    text: "Week Day No",
    formatter: (_, row) => (<span className="text-capitalize">{row?.weekDayNo}</span>),
  },
  {
    dataField: "weekNo",
    text: "Week No",
    formatter: (_, row) => <span className="text-capitalize">{row?.weekNo}</span>,
  },
  {
    dataField: "rank",
    text: "Rank",
    formatter: (_, row) => <span className="text">{row?.rank}</span>,
  },
  {
    dataField: "points",
    text: "Points",
    formatter: (_, row) => <span className="text">{row?.points}</span>,
  },
  {
    dataField: "prizes",
    text: "Prizes",
    formatter: (_, row) => <span className="text-capitalize">{row?.prizes || ""}</span>,
  },
  {
    text: "prizeType",
    dataField: "prizeType",
    formatter: (_, row) => <span className="text-capitalize">{row?.prizeType || ""}</span>,
  },
  {
    dataField: "rewardTransaction",
    text: "Reward Transaction",
    formatter: (_, row) => (
      <div className="d-flex justify-content-center">
        <button
          className={`btn btn-sm ${row?.isLeaderboardTransaction ? "btn-primary" : "btn-success"
            }`}
          onClick={() => handleOpenRewardModal(row)}
        >
          {row?.isLeaderboardTransaction ? (
            <i className="fa fa-eye" />
          ) : (
            <i className="fa fa-plus" />
          )}
        </button>
      </div>
    ),
  },
  // {
  //   text: "Created At",
  //   dataField: "weekNo",
  //   formatter: (_, row) => {
  //     if (!row?.weekNo || !row?.year) return "-";

  //     const endOfWeek = moment.tz('Asia/Tbilisi')
  //       .year(row.year)
  //       .isoWeek(row.weekNo)
  //       .isoWeekday(7)
  //       .endOf('day');

  //     return DATE_FORMAT(endOfWeek);
  //   }
  // },
  {
    text: "Last Updated At",
    dataField: "date_modified_utc",
    formatter: (_, row) => DATE_FORMAT(row?.date_modified_utc),
  },
  {
    text: "Action",
    dataField: "status",
    formatter: (_, row) => (
      <>
        {
          permissions?.edit ?
            <button
              className="fas fa-pen"
              style={{
                fontSize: "16px",
                backgroundColor: "#fff",
                border: "none",
              }
              }
              title="Edit"
              onClick={() =>
                handleEditHandler(row)
              }
            ></button >
            : null}
      </>
    ),
  },
];
export default Columns;
